<template>
  <div
    class="modal fade"
    id="electoralAllianceModal"
    tabindex="-1"
    aria-labelledby="electoralAllianceModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="electoralAllianceModalLabel">
            Valgforbund
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Luk"
          ></button>
        </div>
        <div class="modal-body">
          <p v-if="alliances.length === 0">
            Klik
            <a href="javascript:void(0);" @click="add()">
              Tilføj
            </a>
            for at tilføje et valgforbund.
          </p>

          <div class="accordion" id="accordionExample">
            <div
              class="accordion-item"
              v-for="(alliance, index) in internalAlliances"
              :key="index"
            >
              <h2 class="accordion-header" :id="'heading_' + index">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapse_' + index"
                  aria-expanded="false"
                  :aria-controls="'collapse_' + index"
                >
                  {{ alliance.name }}
                </button>
              </h2>
              <div
                :id="'collapse_' + index"
                class="accordion-collapse collapse"
                :aria-labelledby="'heading_' + index"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Navngiv valgforbund"
                      v-model="alliance.name"
                    />
                  </div>

                  <div style="margin-top: 20px;">
                    <div
                      class="form-check"
                      v-for="(party, partyIndex) in alliance.parties"
                      :key="partyIndex"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="party.letter"
                        @change="onPartyChanged"
                        :checked="party.checked"
                        :id="'party-checkbox-' + partyIndex + '-' + index"
                      />
                      <label
                        class="form-check-label"
                        :for="'party-checkbox-' + partyIndex + '-' + index"
                      >
                        {{ party.name }}
                      </label>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-link"
                    title="Slet valgforbund"
                    @click="deleteAlliance(index)"
                  >
                    Slet
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            v-if="internalAlliances.length < 10"
            class="btn btn-link"
            title="Tilføj valgforbund"
            @click="add"
          >
            Tilføj
          </button>

          <button
            type="button"
            class="btn btn-success"
            data-bs-dismiss="modal"
            @click="onClick"
          >
            Gem
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectoralAlliancesModal',
  watch: {
    alliances: function() {
      this.internalAlliances = [];
    },
  },
  methods: {
    onClick: function() {
      const copy = JSON.parse(JSON.stringify(this.internalAlliances));
      this.$emit('electoralAlliancesChanged', copy);
    },
    add: function() {
      this.internalAlliances.push({
        name: 'Valgforbund ' + (this.alliances.length + 1),
        parties: this.copyParties(),
      });
    },
    deleteAlliance: function(allianceIndex) {
      this.internalAlliances.splice(allianceIndex, 1);
    },
    onPartyChanged: function($event) {
      const partyLetter = $event.target.value;
      const allianceIndex = $event.target.id.substring(
        $event.target.id.lastIndexOf('-') + 1
      );
      const checked = $event.target.checked;

      if (checked) {
        this.internalAlliances.forEach((a) => {
          a.parties.find((p) => p.letter === partyLetter).checked = false;
        });

        this.internalAlliances[allianceIndex].parties.find(
          (p) => p.letter === partyLetter
        ).checked = true;
      } else {
        this.internalAlliances[allianceIndex].parties.find(
          (p) => p.letter === partyLetter
        ).checked = false;
      }
    },
    copyParties: function() {
      const copy = JSON.parse(JSON.stringify(this.parties));
      return copy;
    },
  },
  data: function() {
    return {
      internalAlliances: [],
    };
  },
  mounted() {
    this.alliances.forEach((a) => this.internalAlliances.push(a));
  },
  props: {
    parties: Array,
    alliances: Array,
  },
};
</script>

<style scoped></style>
